// Client→terminal log relay for on-device PWA debugging (no screenshots needed):
// POSTs to the Vite /__cclog middleware, which prints in the dev terminal.
// ponytail: fire-and-forget keepalive POST, no batching/queue.
// OFF by default. Enable on the device: localStorage.setItem('BACK_DEBUG','1')
// or load with ?backdebug=1 (index.html persists it). The /__cclog middleware is
// dev-only (vite.config.ts), so this no-ops in prod.
// Read the flag LIVE per call (not a module-eval const): the PWA may already be
// running when the flag is set, so a const captured at import time would stay
// false until a perfectly-timed reload. Live read = flag works on next render.
function enabled(): boolean {
  return (
    typeof localStorage !== "undefined" &&
    localStorage.getItem("BACK_DEBUG") === "1"
  );
}

export function ccLog(tag: string, msg: string): void {
  if (!enabled()) return;
  try {
    fetch("/__cclog", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ tag, msg }),
      keepalive: true,
    }).catch(() => {});
  } catch {
    /* ignore */
  }
}
